import React from 'react';
import { If, Choose, Otherwise } from 'emerald-ui/lib/Conditionals';

export default {
  name: 'Conditionals',
  githubLink: 'https://github.com/cebroker/emerald-ui/tree/conditionals/src/Conditionals',
  storybookLink: 'http://storybook.emeraldui.com/?path=/story/conditionals--if',
  emeraldLink: 'http://emeraldui.com/Components_Conditionals',
  importCode: `import { If, Choose, Otherwise } from 'emerald-ui/lib/Conditionals';`,
  propsList: [
    {
      component: 'If',
      props: [
        {
          name: 'condition',
          type: 'Boolean',
          default: '',
          description: 'If this condition is <pre>true</pre>, the contents will render',
        },
        {
          name: 'children',
          type: 'Any',
          default: '',
          description: 'Content to be rendered (depending on whether <pre>condition</pre> is true or false)',
        },
      ],
    },
    {
      component: 'Otherwise',
      props: [
        {
          name: 'children',
          type: 'Any',
          default: '',
          description: 'Content to be rendered',
        },
      ],
    },
    {
      component: 'Choose',
      props: [
        {
          name: 'children',
          type: 'If or Otherwise components',
          default: '',
          description: 'Content to be rendered',
        },
      ],
    },
  ],
  description: (
    <span>
      The Conditional components in Emerald-UI are: <br />
      <span className="code">If</span> renders its children only when the condition prop is true.
      <br />
      <span className="code">Otherwise</span> always renders its children.
      <br />
      <span className="code">Choose</span> accepts only If and Otherwise components and renders just the first child
      which condition prop is true. If none is true, the Otherwise children are rendered. Note that the order of the
      children is important here since the first If component found with a true prop condition will be rendered, and
      only that If component.
    </span>
  ),
  codeSamples: [
    {
      title: 'If',
      scope: { If },
      code: `<div>
  <If condition={true}>
    <h1>First condition</h1>
  </If>
  <If condition={false}>
    <h1>Second condition</h1>
  </If>
</div>`,
    },
    {
      title: 'Choose',
      scope: { If, Choose, Otherwise },
      code: `function EasyChoices() {
  const status = 'error';

  return (
    <Choose>
      <If condition={status === 'error'}>
        <h1>Error</h1>
      </If>
      <If condition={status === 'pending'}>
        <h1>Pending</h1>
      </If>
      <Otherwise>
        <h1>Valid</h1>
      </Otherwise>
    </Choose>
  )
}`,
    },
  ],
};
